export const PlFlag = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 3 2"
    height="22px"
  >
    <path
      fill="#fff"
      d="M0 0h3v1H0z"
    />
    <path
      fill="#DC143C"
      d="M0 1h3v1H0z"
    />
  </svg>
);
